export const TZ = "America/Santiago";
const p2 = (n) => String(n).padStart(2, "0");
const fmt = new Intl.DateTimeFormat("en-US", {
  timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short", hourCycle: "h23",
});
const WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

// Fecha/hora de pared en Chile para un instante.
export const clParts = (v) => {
  const o = Object.fromEntries(fmt.formatToParts(new Date(v)).map((x) => [x.type, x.value]));
  return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, wd: WD[o.weekday] };
};
export const clDay = (v) => { const p = clParts(v); return `${p.y}-${p2(p.m)}-${p2(p.d)}`; };
export const clHM = (v) => { const p = clParts(v); return `${p2(p.h)}:${p2(p.mi)}`; };

// Instante que corresponde a "YYYY-MM-DD" + hora:minuto en hora de Chile (respeta horario de verano).
export const clDate = (day, hour, minute) => {
  const [y, m, d] = day.split("-").map(Number);
  const want = Date.UTC(y, m - 1, d, Number(hour), Number(minute));
  let t = want;
  for (let i = 0; i < 2; i += 1) {
    const p = clParts(t);
    t += want - Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi);
  }
  return new Date(t);
};
